import React from 'react';

import Link from '@components/link/Link.tsx';

import I from '../types.ts';

const renderHead: I['renderHead'] = function () {
    const { sections, currentSection, isReady } = this.state;
    const { device } = this.props;

    return (
        <div className="publicBlog__head _ROW">
            <div className="publicBlog__headBlock _COL">
                <h1 className="publicBlog__headTitle">Наш блог</h1>
                {device === 'mobile' && this.renderSearch()}
                <div className="publicBlog__headTabsWrapper">
                    <div className={`publicBlog__headTabs _ROW ${isReady ? '_show' : ''}`}>
                        {(sections || [{ content: 'Все', key: 'all' }]).map((section) => (
                            <Link
                                className={`publicBlog__headTab ${
                                    currentSection === section.key ? '_current' : ''
                                }`}
                                key={section.key}
                                pageName="public-blog-inner"
                                ids={{
                                    2: section.key === 'all' ? '' : section.key,
                                }}
                            >
                                {section.content}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            {device === 'desktop' && (
                <div className="publicBlog__headBlock _COL">{this.renderSearch()}</div>
            )}
        </div>
    );
};

export default renderHead;
